export default "__VITE_ASSET__8f9614c9__"